document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("video[autoplay]").forEach(video => {
        video.muted = true;
        video.play();
    })

    document.querySelectorAll(".password-hero__mute").forEach(btn => {
        btn.addEventListener("click", () => {
            const wrapper = btn.closest(".password-hero");
            const videos = wrapper.querySelectorAll("video");
            const visibleVideo = Array.from(videos).find(v => v.offsetParent !== null);
            const shouldMute = !visibleVideo.muted;

            videos.forEach(video => {
                video.muted = shouldMute;
            })

            btn.textContent = shouldMute ? "Unmute" : "Mute";
            btn.setAttribute("aria-label", shouldMute ? "Unmute video" : "Mute video");
        })
    })


   function syncVideos() {
        document.querySelectorAll(".password-hero").forEach(wrapper => {
            const videos = wrapper.querySelectorAll("video");
            
            if (videos.length <= 1) return;

            const visibleVideo = Array.from(videos).find(v => v.offsetParent !== null);
            const hiddenVideos = Array.from(videos).filter(v => v.offsetParent === null);

            hiddenVideos.forEach(video => {
                video.pause();
                video.muted = true;
            })

            if (visibleVideo) {
                visibleVideo.play();
                const btn = wrapper.querySelector(".password-hero__mute");

                if (btn) {
                    btn.textContent = visibleVideo.muted ? "Unmute" : "Mute";
                    btn.setAttribute("aria-label", visibleVideo.muted ? "Unmute video" : "Mute video");
                }
            }
        })
    }

    document.querySelectorAll(".password-hero").forEach(wrapper => {
        new ResizeObserver(() => syncVideos()).observe(wrapper);
    })
})
